import PropTypes from 'prop-types'

export const MassiveImportNativeSelect = ({
  disabled,
  onChange,
  options,
  placeholder,
  value
}) => {
  return (
    <select
      className='h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-900 outline-none transition focus:border-blue-300 disabled:bg-gray-50 disabled:text-gray-400'
      disabled={disabled}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value=''>{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

MassiveImportNativeSelect.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

MassiveImportNativeSelect.defaultProps = {
  disabled: false,
  placeholder: 'Seleccionar',
  value: ''
}
